import * as React from "react";
import { Link } from "react-router-dom";
import { routeConstants } from "app/routes/route-constants";

const RX_REPLACELINK = /\{(.+?)\}/g;

export const insertGoToSearchLink = (text: string) => {
  const split = text.split(RX_REPLACELINK);
  return split.map((item, index) => {
    if (!(index % 2)) {
      return item;
    } else {
      return (
        <Link key={index} to={routeConstants.createFavouriteDraft}>
          {item}
        </Link>
      );
    }
  });
};
